/* eslint-disable jsx-a11y/control-has-associated-label */
import LazyImage from "@Components/Image";
import config from "@Config/index";
import CloseIcon from "@Icons/CloseIcon";
import formatClassNames from "@Utils/clientUtils/stringUtility/formatClassNames";
import { APP_DOWNLOAD_URL_MOBILE_SMART_BANNER } from "constants/configConstants";
import getAppLink from "@Utils/getAppLink";
import gtagEventEmitter from "helpers/gtagEventEmitter";
import setCookie from "helpers/setCookie";
import useTranslationHook from "hooks/useTranslationHook";
import classes from "./smartbanner.module.scss";
import wrapperHOC from "@Utils/wrapperHOC";
import Button from "@Components/Button";
import Portal from "@Components/Portal";
import BottomSheetOverlay from "@Components/BottomSheetOverlay";
import { Suspense, useEffect, useState } from "react";
import FullPageLoader from "@Components/FullPageLoader";
import Browser from "@Icons/Browser";
import { useLocation } from "react-router";
import isFromCommunicationChannels from "./utils";
import getCookie from "helpers/getCookie";
import useIsDesktop from "hooks/useIsDesktop";
import useCashBackValue from "hooks/useCashBackValue";
import useCustomWindowOpen from "@Components/CustomWindowOpen";

const AppPromotionSmartBanner = ({ from }: any) => {
  const { t } = useTranslationHook();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const isDesktop = useIsDesktop();
  const customWindowOpen = useCustomWindowOpen();

  const [show, setShow] = useState(false);

  useEffect(() => {
    setShow(
      getCookie("showSmartAppBanner") !== "false" &&
        isFromCommunicationChannels(queryParams) &&
        !isDesktop,
    );
  }, []);

  const appRedirectionHandler = () => {
    gtagEventEmitter({
      action: "app_download_smart_banner_click",
      category: "app_download_option",
      value: from,
    });
    customWindowOpen({
      url: getAppLink(APP_DOWNLOAD_URL_MOBILE_SMART_BANNER[from]),
      target: "_blank",
      isExternal: true,
    });
  };

  const handleClose = (cta: string) => {
    setShow(false);
    gtagEventEmitter({
      action: "app_download_smart_banner_dismissed",
      category: "app_download_option",
      page: from,
      cta,
    });
    setCookie({
      cname: "showSmartAppBanner",
      cvalue: "false",
      exdays: 90,
    });
  };
  const cashbackValue = useCashBackValue({ page: from }).displayValue;

  return (
    <Portal rootId="forPortal">
      {show && (
        <BottomSheetOverlay
          hideBottomSheetOverlay={() => handleClose("click outside")}
          forceHideLine
        >
          <Suspense fallback={<FullPageLoader height="30vh" />}>
            <div className={formatClassNames(classes.appWrapper)}>
              <h3 className={classes.title}>
                {t("searchpage.apppromotionbanner.openwith")}
                <div
                  className={classes.closeIcon}
                  onClick={() => handleClose("cross icon")}
                  onKeyDown={(event) => {
                    if (event.key === "Enter") {
                      handleClose("cross icon");
                    }
                  }}
                  role="button"
                  tabIndex={0}
                >
                  <CloseIcon size={16} stroke="#111928" strokeWidth="2" />
                </div>
              </h3>
              <div className={classes.wrapper}>
                <div className={classes.container}>
                  <div className={classes.innerContainer}>
                    <LazyImage
                      src={
                        config.IS_CHINA_APP
                          ? `${config.IMAGE_STATIC_URL}/images/amber-app-logo.svg`
                          : `${config.IMAGE_STATIC_ASSETS_COMPONENTS_PATH}/AppPromotionBanner/assets/amber-app-logo.png`
                      }
                      alt="amber-app"
                      height="40px"
                      width="40px"
                      isNotLazy
                    />
                    <div className={classes.titleInnerContainer}>
                      {t("Amber app")}
                      <div className={classes.innerText}>
                        <span>Get {cashbackValue} off</span>{" "}
                        {t("searchpage.apppromotionbanner.onbooking")}
                      </div>
                    </div>
                  </div>
                  <Button
                    variant="primary"
                    className={classes.btn}
                    onClick={() => appRedirectionHandler()}
                  >
                    {t("searchpage.apppromotionbanner.useapp")}
                  </Button>
                </div>
                <div className={classes.container}>
                  <div className={classes.innerContainer}>
                    <Browser />
                    {t("searchpage.apppromotionbanner.browser")}
                  </div>
                  <Button
                    variant="outline"
                    className={classes.btn}
                    onClick={() => handleClose("continue")}
                  >
                    {t("searchpage.apppromotionbanner.continue")}
                  </Button>
                </div>
              </div>
            </div>
          </Suspense>
        </BottomSheetOverlay>
      )}
    </Portal>
  );
};

export default wrapperHOC(AppPromotionSmartBanner, {
  componentName: "AppPromotionSmartBanner",
  showForChina: true,
  showForWhiteLable: false,
  showForApp: false,
});
